import { createSelector } from "reselect";
const _selectSnackbarState= state => state.snackbar;

export  const  selectSnackbar = createSelector(
    [_selectSnackbarState],
    snackbar => snackbar
)
